import React from 'react';
import { GroupBox } from '../shared/GroupBox';
import { Button } from '../ui/button';
import { Settings, Database, Shield, Bell, Palette } from 'lucide-react';

export function UtilitiesPage() {
  return (
    <div className="space-y-4" data-testid="utilities-page">
      <h1 className="font-heading text-2xl font-bold">Utilities</h1>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        <GroupBox label="Data Management">
          <div className="space-y-2">
            <Button variant="outline" className="w-full justify-start" disabled>
              <Database className="h-4 w-4 mr-2" />
              Export All Data
            </Button>
            <Button variant="outline" className="w-full justify-start" disabled>
              <Database className="h-4 w-4 mr-2" />
              Import Data
            </Button>
            <Button variant="outline" className="w-full justify-start text-destructive" disabled>
              <Database className="h-4 w-4 mr-2" />
              Clear All Transactions
            </Button>
          </div>
        </GroupBox>

        <GroupBox label="Security">
          <div className="space-y-2">
            <Button variant="outline" className="w-full justify-start" disabled>
              <Shield className="h-4 w-4 mr-2" />
              Change Password
            </Button>
            <Button variant="outline" className="w-full justify-start" disabled>
              <Shield className="h-4 w-4 mr-2" />
              Two-Factor Auth
            </Button>
            <Button variant="outline" className="w-full justify-start" disabled>
              <Shield className="h-4 w-4 mr-2" />
              Session Management
            </Button>
          </div>
        </GroupBox>

        <GroupBox label="Preferences">
          <div className="space-y-2">
            <Button variant="outline" className="w-full justify-start" disabled>
              <Bell className="h-4 w-4 mr-2" />
              Notification Settings
            </Button>
            <Button variant="outline" className="w-full justify-start" disabled>
              <Palette className="h-4 w-4 mr-2" />
              Display Settings
            </Button>
            <Button variant="outline" className="w-full justify-start" disabled>
              <Settings className="h-4 w-4 mr-2" />
              Default Values
            </Button>
          </div>
        </GroupBox>
      </div>

      <GroupBox label="System Information">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          <div>
            <p className="text-muted-foreground text-xs uppercase tracking-wider">Version</p>
            <p className="font-mono">1.0.0</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs uppercase tracking-wider">Build</p>
            <p className="font-mono">2025.01</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs uppercase tracking-wider">Environment</p>
            <p className="font-mono">Production</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs uppercase tracking-wider">API Status</p>
            <p className="font-mono text-emerald-500">Connected</p>
          </div>
        </div>
      </GroupBox>

      <div className="text-center text-sm text-muted-foreground py-8">
        <p>Additional utilities will be available in future updates.</p>
      </div>
    </div>
  );
}
